import {GrantedPermissionSet, GrantedPermissionSetResolver} from "../right.service";
import {OperationRights} from "../../app.right-definitions";

export class CustomStatisticsRightModel {

  public readonly delete: GrantedPermissionSet;
  public readonly create: GrantedPermissionSet;
  public readonly read: GrantedPermissionSet;
  public readonly update: GrantedPermissionSet;

  constructor(resolver: GrantedPermissionSetResolver) {
    this.delete = resolver.of(OperationRights.CUSTOM_STATISTICS_DELETE);
    this.create = resolver.of(OperationRights.CUSTOM_STATISTICS_CREATE);
    this.read = resolver.of(OperationRights.CUSTOM_STATISTICS_READ);
    this.update = resolver.of(OperationRights.CUSTOM_STATISTICS_UPDATE);
  }
}
